import React, { useRef, useEffect, useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { Divider, Skeleton, TextField, Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { usePrompt } from "../../Hooks/useBlocker";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { DragDropContext } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import Actions from "./Actions";
import RegularTableRow from "./RegularTableRow";
import SingleTableRow from "./SingleTableRow";
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";
import "react-virtualized/styles.css"; // only needs to be imported once

function Body({
  rows,
  filteredColumns,
  columns,
  options,
  editIndex,
  setEditIndex,
  rowCopy,
  setRowCopy,
  height,
  width,
  isScrolling,
  onChildScroll,
  scrollTop,
  registerChild,
}) {
  const [saved, setSaved] = useState(true);
  const [style, setStyle] = useState({});

  const currentFocus = useRef([]);

  const isFirstRender = useRef(true);

  usePrompt("If you leave without saving you will loss your data?", !saved);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // console.log("rowCopy");

    if (!rowCopy) return;

    options?.onChange?.(rows, rowCopy);
  }, [rowCopy]);

  console.log("render", width);

  const cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 55,
  });


  function rowRenderer({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it)
    parent,
  }) {
    // style = {
    //   position: "inherit",
    // };

    const item = (
      // <Draggable
      //   key={index}
      //   draggableId={String(rows[index]["draggableId"])}
      //   index={index}
      // >
      //   {(provided, snapshot) => (
          <CellMeasurer
            key={key}
            cache={cache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            {({ registerChild }) => (
              <Box ref={registerChild} sx={{ width: "100%" }}>
                <Divider  sx={{
                  marginRight: "-450px",
                }} />
                <RegularTableRow
                  index={index}
                  // provided={provided}
                  row={rows[index]}
                  // snapshot={snapshot}
                  editIndex={editIndex}
                  saved={saved}
                  isLoading={!isVisible && isScrolling}
                  currentFocus={currentFocus}
                  validate={validate}
                  setSaved={setSaved}
                  setEditIndex={setEditIndex}
                  rowCopy={rowCopy}
                  setRowCopy={setRowCopy}
                  columns={columns}
                  options={options}
                  filteredColumns={filteredColumns}
                />
              </Box>
            )}
          </CellMeasurer>
      //   )}
      // </Draggable>
    );

    return (
      <div key={key} style={style}>
        {item}
      </div>
    );
  }

  function validate(row) {
    function save() {
      options?.save(rowCopy, row);

      setSaved(true);

      setEditIndex(false);

      setRowCopy(false);
    }

    function fillRequerments() {
      alert("Please fill in all required information");

      function focus(i) {
        setTimeout(() => currentFocus.current[i].focus(), 500);
      }

      let i = 0;
      let done = false;
      do {
        if (row[options?.singleRowId]) {
          if (
            columns.find((item) => item.id === options?.singleRowId)
              ?.required === true
          ) {
            if (!rowCopy[options?.singleRow]) {
              focus(0);

              done = true;
            }
          }
          done = true;
        } else {
          if (columns[i].required === true) {
            if (!rowCopy[columns[i].id]) {
              focus(i);

              done = true;
            }
          } else {
            if (!columns[i]) {
              done = true;
            }
          }
        }

        i += 1;
      } while (done === false);

      setSaved(false);
    }

    if (row[options.singleRowId] === true) {
      if (row[options.singleRow]) {
        save();
      } else {
        fillRequerments();
      }
    } else {
      const filledRequerments = filteredColumns
        .filter(
          (item) => item.required === true && item.id !== options.singleRowId
        )
        .map((column, i) => {
          if (rowCopy[column.id]) {
            return true;
          } else {
            return false;
          }
        });

      if (!filledRequerments.includes(false)) {
        save();
      } else {
        fillRequerments();
      }
    }
  }

  function onDragEnd(r, rowCopy) {
    options.onDragEnd?.(r);
  }

  return (
    // <DragDropContext onDragEnd={(r) => onDragEnd(r)}>
      <TableBody
        sx={{
          width: "100%",
          height: "100%",
        minHeight: 0,
          border:"none"
        }}
      >
        {/* <Droppable droppableId={"1"} key={1} index={1}>
          {(provided) => ( */}
            <Box
              // ref={provided.innerRef}
              // {...provided.droppableProps}
              sx={{ width: "100%" }}
            >
              <List
                autoHeight
                autoWidth
                height={height}
                width={width}
                isScrolling={isScrolling}
                rowCount={rows.length}
                scrollTop={scrollTop}
                deferredMeasurementCache={cache}
                rowHeight={cache.rowHeight}
                rowRenderer={rowRenderer}
                overscanRowCount={3}
                style={{
                  position: "inherit",
                  width: "100%",
                  overflowY: "unset !important",
                  overflowX: "unset !important",
                }}
                containerStyle={{
                  width: "100%",
                  overflow: "inherit !important",
                  // position: "inherit",
                }}
              />
            </Box>
          {/* )}
        </Droppable>
         */}
        {options.customRows || null}

        <Box sx={{ height: "80px" }}></Box>
      </TableBody>
    // {/* </DragDropContext> */}
  );
}

export default Body;
